<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange" @selection-change="handleSelectionChange"
        @size-change="pageSizeChange" @current-change="pageChange">
        <template slot="menuLeft">
          <el-button type="text" size="small" icon="el-icon-download" @click="handleExport">导出Excel</el-button>
        </template>
      </avue-crud>

      <!-- 退货弹窗 -->
      <el-dialog title="退货确认" :visible.sync="refundDialogVisible" width="500px" :close-on-click-modal="false">
        <el-form :model="refundForm" label-width="100px" :rules="refundRules" ref="refundFormRef">
          <el-form-item label="订单编号">
            <span>{{ refundForm.orderNumber }}</span>
          </el-form-item>
          <el-form-item label="商品名称">
            <span>{{ refundForm.goodsName }}</span>
          </el-form-item>
          <el-form-item label="购买数量">
            <span>{{ refundForm.buyCount }}</span>
          </el-form-item>
          <el-form-item label="购买单价">
            <span>{{ refundForm.unitPrice }} 元</span>
          </el-form-item>
          <el-form-item label="退货数量" prop="refundCount">
            <el-input v-model="refundForm.refundCount" placeholder="请输入退货数量" @input="handleReturnCountInput"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="refundDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleConfirmReturn">确 认</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { commerceGoodsReturnOption } from "@/const/salesCloud/commerceGoodsReturnOption";
import { findReturnList, confirmReturn, exportReturnExcel } from "@/api/salesCloud/commerceGoodsReturn";

export default {
  name: "commerceGoodsReturn",
  data() {
    return {
      tableOption: commerceGoodsReturnOption,
      tableData: [],
      tableLoading: false,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      selectionList: [],
      // 退货弹窗
      refundDialogVisible: false,
      refundForm: {
        id: "",
        orderNumber: "",
        goodsName: "",
        buyCount: 0,
        unitPrice: 0,
        refundCount: ""
      },
      refundRules: {
        refundCount: [
          { required: true, message: "请输入退货数量", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.handleList();
  },
  methods: {
    // 退货数量只能输入数字
    handleReturnCountInput(val) {
      this.refundForm.refundCount = val.replace(/[^\d]/g, "");
    },
    // 构建搜索参数
    buildSearchParams(params) {
      let result = { ...params };
      // 除状态和时间外，文本搜索字段统一用 searchParams 传参
      let searchValue = '';
      if (result.refundNumber) searchValue = result.refundNumber.trim();
      else if (result.orderNumber) searchValue = result.orderNumber.trim();
      else if (result.goodsName) searchValue = result.goodsName.trim();
      else if (result.refundUserPhone) searchValue = result.refundUserPhone.trim();
      result.searchParams = searchValue;
      // 删除原始字段，避免多余参数
      delete result.refundNumber;
      delete result.orderNumber;
      delete result.goodsName;
      delete result.refundUserPhone;
      return result;
    },
    // 加载列表
    handleList() {
      this.tableLoading = true;
      let params = this.buildSearchParams(this.$refs.crud ? this.$refs.crud.searchForm : {});
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findReturnList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    // avue-crud 搜索事件
    searchChange(params) {
      this.page.currentPage = 1;
      this.tableLoading = true;
      params = this.buildSearchParams(params);
      params.page = 1;
      params.size = this.page.pageSize;
      findReturnList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: 1,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    // 刷新
    refreshChange() {
      this.handleList();
    },
    // 分页大小改变
    pageSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.handleList();
    },
    // 分页页码改变
    pageChange(currentPage) {
      this.page.currentPage = currentPage;
      this.handleList();
    },
    // 选择项改变
    handleSelectionChange(list) {
      this.selectionList = list;
    },
    // 导出
    handleExport() {
      let params = this.buildSearchParams(this.$refs.crud.searchForm);
      delete params.page;
      delete params.size;
      exportReturnExcel(params).then((response) => {
          console.log(response)
        // 提取文件名
        const filename = response.headers["content-disposition"].match(
          /filename=(.*)/
        )[1];
        // 将二进制流转为blob
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
          window.navigator.msSaveBlob(blob, decodeURI(filename));
        } else {
          // 创建新的URL并指向File对象或者Blob对象的地址
          const blobURL = window.URL.createObjectURL(blob);
          // 创建a标签，用于跳转至下载链接
          const tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", decodeURI(filename));
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          // 挂载a标签
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          // 释放blob URL地址
          window.URL.revokeObjectURL(blobURL);
          this.searchChange(params);
        }
      });
    },
    // 打开退货弹窗
    openReturnDialog(row) {
      this.refundForm = {
        id: row.id,
        orderNumber: row.orderNumber,
        goodsName: row.goodsName,
        buyCount: row.buyCount,
        unitPrice: row.unitPrice,
        refundCount: ""
      };
      this.refundDialogVisible = true;
    },
    // 确认退货
    handleConfirmReturn() {
      this.$refs.refundFormRef.validate(valid => {
        if (valid) {
          let refundCount = parseInt(this.refundForm.refundCount);
          if (refundCount <= 0) {
            this.$message({
              showClose: true,
              message: "退货数量必须大于0",
              type: "error"
            });
            return;
          }
          if (refundCount > this.refundForm.buyCount) {
            this.$message({
              showClose: true,
              message: "退货数量不能大于购买数量",
              type: "error"
            });
            return;
          }
          let data = {
            id: this.refundForm.id,
            refundCount: refundCount
          };
          confirmReturn(data).then(res => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message: "退货成功",
                type: "success"
              });
              this.refundDialogVisible = false;
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error || "操作失败",
              type: "error"
            });
          });
        }
      });
    }
  }
};
</script>

<style scoped></style>
